jQuery(document).ready(function($) {
  // Sticky nav
  let scrollThreshold = 0;
  let targetElement = $('header.header');
  let scrollClass = 'scrolling';

  checkScrollPosition();
  
  $(window).scroll(function() {
    checkScrollPosition();
  });

  function checkScrollPosition(){
    if ($(window).scrollTop() > scrollThreshold) {
      $(targetElement).addClass(scrollClass);
    } else {
      $(targetElement).removeClass(scrollClass);
    }
  }


  //hide alert banner 
  $('.hide-alert-banner span').click(function(){
    $('.alert-banner').hide();
    $('.alert-banner-visible').removeClass('alert-banner-visible');
  });
});